/*=========================================================================================
File Name: router.js
Description: Routes for vue-router. Lazy loading is enabled.
----------------------------------------------------------------------------------------
Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
Author: Pixinvent
Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import Vue from 'vue'
import Router from 'vue-router'
import store from './store/store'
// import axios from "@/axios.js"


Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior () {
    return { x: 0, y: 0 }
  },
  routes: [
    
    {
      // =============================================================================
      // MAIN LAYOUT ROUTES
      // =============================================================================
      path: '',
      component: () => import('./layouts/main/Main.vue'),
      children: [
        // =============================================================================
        // Theme Routes
        // =============================================================================
        {
          path: '/',
          name: 'home',
          component: () => import('./views/Home.vue'),
          beforeEnter: () => {
            router.push('/packages/list')
          }
        },
        {
          path: '/page2',
          name: 'page-2',
          component: () => import('./views/Page2.vue')
        },
        {
          path: '/packages/list',
          name: 'package-list',
          component: () => import('./views/packages/package-list/PackageList.vue'),
          beforeEnter: (to, from, next) => {
            guard(to, from, next);
          }
        },
        {
          path: '/package/package-edit/:packageId',
          name: 'package-edit',
          component: () => import('./views/packages/package-edit/PackageEdit.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Pedidos', url: '/packages/list' },
              { title: 'Informações', active: true },
            ],
            pageTitle: 'Informações Sobre Pedido',
            rule: 'editor'
          },
        },
        {
          path: '/credentials/sigep',
          name: 'sigep',
          component: () => import('./views/credentials/Sigep.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Sigep', active: true },
            ],
            pageTitle: 'Sigep'
          },
        },
        {
          path: '/credentials/sigep/help/id-correios',
          name: 'help-id-correios',
          component: () => import('./views/credentials/helps/SigepHelpIdCorreios.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Sigep', active: true },
            ],
            pageTitle: 'Sigep'
          },
        },
        {
          path: '/credentials/sigep/help/codigo-api',
          name: 'help-codigo-api',
          component: () => import('./views/credentials/helps/SigepHelpCodigoApi.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Sigep', active: true },
            ],
            pageTitle: 'Sigep'
          },
        },
      ],
    },
    // =============================================================================
    // FULL PAGE LAYOUTS
    // =============================================================================
    {
      path: '',
      component: () => import('@/layouts/full-page/FullPage.vue'),
      children: [
        // =============================================================================
        // PAGES
        // =============================================================================
        {
          path: '/pages/login',
          name: 'page-login',
          component: () => import('@/views/pages/Login.vue')
        },
        {
          path: '/pages/error-404',
          name: 'page-error-404',
          component: () => import('@/views/pages/Error404.vue')
        },
      ]
    },
    // Redirect to 404 page, if no match found
    {
      path: '*',
      redirect: '/pages/error-404'
    }
  ],
})

const guard = function(to, from, next) {
  // check for valid auth token
  store.dispatch("sigep/validateCreds").then(response => {
    if(response.valid === true)
      next();
    else
    router.push('/credentials/sigep')
  }).catch(() => {
    router.push('/credentials/sigep');
  })
  
};


router.beforeEach((to, from, next) => {
  // redirect to login page if not logged in and trying to access a restricted page
  const publicPages = ['/pages/login', '/pages/error-404'];
  const authRequired = !publicPages.includes(to.path);
  const loggedIn = store.state.auth.isUserLoggedIn();
  
  
  if (authRequired && !loggedIn) {
    return next('/pages/login');
  }
  else if(!authRequired && loggedIn) {
    return next('/');
  }
  
  next();
})


router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg')
  if (appLoading) {
    appLoading.style.display = "none";
  }
})

export default router
